<script setup>
import { Head, useForm } from '@inertiajs/vue3';
import Button from 'primevue/button';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import GuestLayout from '@/Layouts/GuestLayout.vue';

const props = defineProps({
  email: {
    type: String,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
});

const form = useForm({
  token: props.token,
  email: props.email,
  password: '',
  password_confirmation: '',
});

const submit = () => {
  form.post(route('password.store'), {
    onFinish: () => form.reset('password', 'password_confirmation'),
  });
};
</script>

<template>
  <GuestLayout>
    <Head title="Réinitialisation de mot de passe"/>

    <form @submit.prevent="submit">
      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="email"
              type="email"
              fluid
              autofocus
              autocomplete="username"
              required
              v-model="form.email"
              :invalid="!!form.errors.email"
          />

          <label for="email">Adresse e-mail</label>
        </FloatLabel>

        <Message v-if="!!form.errors.email" severity="error">
          {{ form.errors.email }}
        </Message>
      </div>

      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="password"
              type="password"
              fluid
              autocomplete="new-password"
              required
              v-model="form.password"
              :invalid="!!form.errors.password"
          />

          <label for="email">Nouveau mot de passe</label>
        </FloatLabel>

        <Message v-if="!!form.errors.password" severity="error">
          {{ form.errors.password }}
        </Message>
      </div>

      <div class="mt-6 flex flex-col gap-2">
        <FloatLabel variant="on">
          <InputText
              id="password_confirmation"
              type="password"
              fluid
              autocomplete="new-password"
              required
              v-model="form.password_confirmation"
              :invalid="!!form.errors.password_confirmation"
          />

          <label for="email">Confirmation du mot de passe</label>
        </FloatLabel>

        <Message v-if="!!form.errors.password_confirmation" severity="error">
          {{ form.errors.password_confirmation }}
        </Message>
      </div>

      <div class="my-6 flex items-center justify-end">
        <Button type="submit" class="ml-4" :disabled="form.processing">
          Changer le mot de passe
        </Button>
      </div>
    </form>
  </GuestLayout>
</template>
